export var LiquidatorExchangeMethodEnum;
(function (LiquidatorExchangeMethodEnum) {
    LiquidatorExchangeMethodEnum["RESERVE"] = "RESERVE";
    LiquidatorExchangeMethodEnum["MARKET"] = "MARKET";
    LiquidatorExchangeMethodEnum["LIMIT"] = "LIMIT";
})(LiquidatorExchangeMethodEnum || (LiquidatorExchangeMethodEnum = {}));
//# sourceMappingURL=liquidator-exchange-method.enum.js.map